import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';
import { defineMessages, useIntl } from '@atlas/text';

export const messages = defineMessages({
    tick: { id: 'lblIconTick', defaultMessage: 'Tick' },
});

const TickIcon = React.memo(function TickIcon(props: TTickIconProps): React.ReactElement {
    const intl = useIntl();

    return (
        <IconBase aria-label={intl.formatMessage(messages.tick)} viewBox="0 0 10 10" {...props}>
            <path
                clipRule="evenodd"
                fillRule="evenodd"
                d="M9.223 1.154a.75.75 0 0 1 .14 1.052l-4.97 6.5a.75.75 0 0 1-1.127.074L.59 6.104a.75.75 0 1 1 1.06-1.06l2.071 2.07 4.45-5.82a.75.75 0 0 1 1.052-.14Z"
            />
        </IconBase>
    );
});

export default TickIcon;

// #region Types

export type TTickIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <TickIcon /> : { ...IconBaseExample, render: TickIcon };

// #endregion
